import React from "react";
import { Reveal, SectionLabel } from "../components/primitives";
import { Linkedin, Mail } from "lucide-react";

const TEAM = [
  {
    name: "Nikhil Anand Khurana",
    role: "Chief Investment Officer",
    affil: "Folks Funds · Folks Motor · Folks Finance",
    bio: "Architect of the Folks ecosystem. Leads investment strategy across the 13 ESG sectors and orchestrates Motor + Finance to accelerate portfolio companies.",
    initials: "NK",
    photo: "/team/nikhil.png",
    linkedin: "https://www.linkedin.com/in/nikhil-khurana/",
    email: "nikhil.khurana@folksmotor.com",
  },
  {
    name: "Gaurav Kumar Tiwari",
    role: "Principal",
    affil: "NIT Tiruchirappalli · Deeptech Investor",
    bio: "Deep technical sector expertise across energy storage, hydrogen and industrial decarbonization. Drives diligence, TRL assessment and portfolio engineering.",
    initials: "GT",
    photo: "/team/gaurav.png",
    linkedin: "https://www.linkedin.com/in/gaurav-kumar-tiwari-34a4ab221/",
    email: "gaurav.tiwari@folksfunds.com",
  },
];

export default function Team() {
  return (
    <div data-testid="team-page">
      <section className="pt-20 pb-12 lg:pt-32 lg:pb-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionLabel>Team</SectionLabel>
          <h1 className="font-display font-bold tracking-[-0.035em] leading-[0.94] text-5xl sm:text-7xl lg:text-[104px] text-[#111A15] max-w-5xl">
            The folks behind Folks.
          </h1>
          <p className="mt-10 max-w-2xl text-[17px] text-[#4A5E51] leading-relaxed">
            Investors, operators and compliance leaders building India's first ESG-integrated AIF Cat II fund.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24 border-y border-[#E5E5E0] bg-[#E8ECE9]/40">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E5E5E0] border border-[#E5E5E0]">
          {TEAM.map((m, i) => (
            <Reveal key={m.name} delay={i * 90}>
              <article data-testid={`team-card-${m.initials.toLowerCase()}`} className="group bg-white p-8 lg:p-10 h-full flex flex-col">
                <div className="aspect-[4/5] bg-gradient-to-br from-[#1A2F24] to-[#111A15] relative mb-8 overflow-hidden">
                  <img
                    src={m.photo}
                    alt={m.name}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover object-top grayscale-[0.15] group-hover:grayscale-0 transition-[filter] duration-500"
                  />
                  <div className="absolute inset-0 ring-1 ring-inset ring-black/5"></div>
                  <span className="absolute bottom-3 left-3 font-mono text-[10px] uppercase tracking-[0.22em] text-white/90 mix-blend-difference z-10">— 0{i + 1}</span>
                </div>
                <h2 className="font-display font-semibold tracking-tight text-2xl lg:text-3xl text-[#111A15]">{m.name}</h2>
                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[#C44900] mt-2">{m.role}</p>
                <p className="text-[12px] text-[#4A5E51] mt-2 italic">{m.affil}</p>
                <p className="text-[14px] text-[#4A5E51] leading-relaxed mt-6">{m.bio}</p>
                <div className="mt-auto pt-6 flex items-center gap-3">
                  <a href={m.linkedin} target="_blank" rel="noopener noreferrer" data-testid={`team-linkedin-${m.initials.toLowerCase()}`} aria-label={`${m.name} LinkedIn`} className="w-9 h-9 grid place-items-center border border-[#E5E5E0] hover:bg-[#111A15] hover:text-white hover:border-[#111A15] transition-colors">
                    <Linkedin className="w-4 h-4" strokeWidth={1.5} />
                  </a>
                  <a href={`mailto:${m.email}`} data-testid={`team-email-${m.initials.toLowerCase()}`} aria-label={`Email ${m.name}`} className="inline-flex items-center gap-2 h-9 px-3 border border-[#E5E5E0] text-[12px] text-[#4A5E51] hover:bg-[#111A15] hover:text-white hover:border-[#111A15] transition-colors font-mono">
                    <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
                    <span className="truncate max-w-[200px]">{m.email}</span>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-24 lg:py-32">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
          <p className="font-display font-medium tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#111A15] leading-[1.1]">
            "We are not just a cheque. We are a system where proprietary technology meets world-class manufacturing infrastructure to create scalable assets."
          </p>
          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-[#4A5E51]">— Folks Funds</p>
        </div>
      </section>
    </div>
  );
}
